import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import radiusOptions from '../../common/radius-options/radius-options.esm.js';
import sizeOptions from '../../common/size-options/size-options.esm.js';

var skeletonTV = getTvObject({
  variants: _objectSpread2(_objectSpread2({}, sizeOptions), {}, {
    animation: {
      wave: ['relative', 'overflow-hidden', 'bg-neutral-subtlest', 'after:absolute', 'after:inset-0', 'after:animate-linear-wave', 'after:bg-gradient-to-r', 'after:from-transparent', 'after:via-neutral', 'after:to-transparent', 'after:-translate-x-full'],
      pulse: ['bg-neutral-subtle', 'animate-pulse']
    },
    radius: radiusOptions.radius
  })
});
var base = tv(skeletonTV);
var skeletonStyles = {
  base: base
};

export { skeletonStyles, skeletonTV };
//# sourceMappingURL=skeleton.styles.esm.js.map
